import type { ProjectRequirementsCoverageReport } from "../types/requirementsCoverage";

export async function fetchProjectRequirementsCoverage(
  projectId: string,
): Promise<ProjectRequirementsCoverageReport> {
  if (!projectId) {
    throw new Error("projectId is required");
  }

  const response = await fetch(
    `/api/projects/${encodeURIComponent(projectId)}/requirements/coverage`,
  );
  const payload = (await response.json()) as ProjectRequirementsCoverageReport & {
    error?: string;
  };

  if (!response.ok) {
    const message = payload.error ?? `Failed to load coverage (status ${response.status})`;
    throw new Error(message);
  }

  return payload;
}
